import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SidebarNavigation = ({ activeSection, onSectionChange }) => {
  const [expandedSections, setExpandedSections] = useState({
    authentication: true,
    endpoints: true,
    examples: false,
    sdks: false,
    webhooks: false
  });

  const navigationSections = [
    {
      id: 'getting-started',
      title: 'Getting Started',
      icon: 'BookOpen',
      items: [
        { id: 'overview', title: 'Overview' },
        { id: 'quick-start', title: 'Quick Start' },
        { id: 'rate-limits', title: 'Rate Limits' }
      ]
    },
    {
      id: 'authentication',
      title: 'Authentication',
      icon: 'Key',
      items: [
        { id: 'api-keys', title: 'API Keys' },
        { id: 'auth-methods', title: 'Auth Methods' },
        { id: 'security', title: 'Security Best Practices' }
      ]
    },
    {
      id: 'endpoints',
      title: 'API Endpoints',
      icon: 'Globe',
      items: [
        { id: 'single-validation', title: 'Single Email Validation' },
        { id: 'bulk-validation', title: 'Bulk Email Validation' },
        { id: 'domain-check', title: 'Domain Verification' },
        { id: 'disposable-check', title: 'Disposable Email Check' }
      ]
    },
    {
      id: 'local-testing',
      title: 'Local Testing',
      icon: 'Terminal',
      items: [
        { id: 'curl-commands', title: 'cURL Commands' },
        { id: 'supabase-setup', title: 'Supabase Setup' },
        { id: 'testing-guide', title: 'Testing Guide' }
      ]
    },
    {
      id: 'examples',
      title: 'Code Examples',
      icon: 'Code',
      items: [
        { id: 'javascript', title: 'JavaScript' },
        { id: 'python', title: 'Python' },
        { id: 'php', title: 'PHP' },
        { id: 'curl', title: 'cURL' }
      ]
    },
    {
      id: 'sdks',
      title: 'SDKs & Libraries',
      icon: 'Package',
      items: [
        { id: 'node-sdk', title: 'Node.js SDK' },
        { id: 'python-sdk', title: 'Python SDK' },
        { id: 'php-sdk', title: 'PHP SDK' }
      ]
    },
    {
      id: 'webhooks',
      title: 'Webhooks',
      icon: 'Webhook',
      items: [
        { id: 'webhook-setup', title: 'Setup & Configuration' },
        { id: 'webhook-events', title: 'Event Types' },
        { id: 'webhook-security', title: 'Security & Verification' }
      ]
    },
    {
      id: 'reference',
      title: 'Reference',
      icon: 'FileText',
      items: [
        { id: 'error-codes', title: 'Error Codes' },
        { id: 'response-formats', title: 'Response Formats' },
        { id: 'changelog', title: 'Changelog' }
      ]
    }
  ];

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const handleItemClick = (sectionId, itemId) => {
    onSectionChange(`${sectionId}-${itemId}`);
  };

  return (
    <div className="h-full bg-surface border-r border-border overflow-y-auto">
      <div className="p-4 border-b border-border">
        <h2 className="text-lg font-semibold text-text-primary">API Documentation</h2>
        <p className="text-sm text-text-secondary mt-1">Complete integration guide</p>
      </div>
      
      <nav className="p-4 space-y-2">
        {navigationSections.map((section) => (
          <div key={section.id} className="space-y-1">
            <button
              onClick={() => toggleSection(section.id)}
              className="w-full flex items-center justify-between p-2 text-left hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              <div className="flex items-center space-x-2">
                <Icon name={section.icon} size={16} className="text-text-secondary" />
                <span className="text-sm font-medium text-text-primary">{section.title}</span>
              </div>
              <Icon 
                name="ChevronDown" 
                size={16} 
                className={`text-text-secondary transition-transform duration-200 ${
                  expandedSections[section.id] ? 'rotate-180' : ''
                }`} 
              />
            </button>
            
            {expandedSections[section.id] && (
              <div className="ml-6 space-y-1">
                {section.items.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleItemClick(section.id, item.id)}
                    className={`w-full text-left p-2 text-sm rounded-md transition-colors duration-200 ${
                      activeSection === `${section.id}-${item.id}`
                        ? 'bg-primary/10 text-primary font-medium' :'text-text-secondary hover:text-text-primary hover:bg-gray-50'
                    }`}
                  >
                    {item.title}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default SidebarNavigation;